import {
    KERNEL_SCOPE_FAILURE_CATEGORY,
    applyScopeToSpec,
} from "./kernelScope.js";

export class KernelPublishabilityError extends Error {
    constructor(failures) {
        const first = failures[0];
        const step = first?.stepId
            ? ` "${first.stepId}"`
            : ` ${Number(first?.stepIndex ?? 0) + 1}`;
        super(
            `Kernel cannot be published: analytics step${step} cannot apply viewer scope safely`
            + `${first?.reason ? ` (${first.reason})` : ""}.`,
        );
        this.name = "KernelPublishabilityError";
        this.code = "kernel-scope-not-publishable";
        this.failures = failures;
    }
}

/**
 * Publishing a scoped definition is a human-facing semantic transition.
 * Catch the definition-only failures here while the author can fix them;
 * runtime still repeats this check with the viewer's actual scope.
 */
export function kernelPublishScopeFailures(kernel) {
    if (kernel?.scopeMode !== "scoped" || !Array.isArray(kernel?.steps)) {
        return [];
    }

    const failures = [];
    kernel.steps.forEach((step, stepIndex) => {
        if (step?.kind !== "analytics_query") return;
        const result = applyScopeToSpec(step.spec, []);
        if (
            result.scoped !== true
            && result.reasonCategory === KERNEL_SCOPE_FAILURE_CATEGORY.DEFINITION_SHAPE
        ) {
            failures.push(Object.freeze({
                stepId: typeof step.id === "string" && step.id ? step.id : null,
                stepIndex,
                reason: result.reason || "scope could not be applied",
                reasonCode: result.reasonCode || "scope-unresolvable",
                reasonCategory: result.reasonCategory,
            }));
        }
    });
    return failures;
}

export function assertKernelScopePublishable(kernel) {
    const failures = kernelPublishScopeFailures(kernel);
    if (failures.length) throw new KernelPublishabilityError(failures);
    return kernel;
}
